import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const AfiliadoFarmaCardReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(Types.CONSULTAR_AFILIADO_FARMA_CARD_LOADING, (state) => {
      state.consultarAfiliadoFarmaCardLoading = true;
      state.consultarAfiliadoFarmaCardError = null;
    })
    .addCase(Types.CONSULTAR_AFILIADO_FARMA_CARD_SUCCESS, (state, action) => {
      const { consultarAfiliadoFarmaCardData } = action;
      state.consultarAfiliadoFarmaCardData = consultarAfiliadoFarmaCardData;
      state.consultarAfiliadoFarmaCardLoading = false;
      state.limpiarDatosAfiliadoFarmaCardLoading = false;
      state.consultarAfiliadoFarmaCardError = null;
    })
    .addCase(Types.CONSULTAR_AFILIADO_FARMA_CARD_FAILURE, (state, action) => {
      const { consultarAfiliadoFarmaCardError } = action;
      state.consultarAfiliadoFarmaCardData = INITIAL_STATE.consultarAfiliadoFarmaCardData;
      state.consultarAfiliadoFarmaCardLoading = false;
      state.limpiarDatosAfiliadoFarmaCardLoading = false;
      state.consultarAfiliadoFarmaCardError = consultarAfiliadoFarmaCardError;
    });

  builder.addCase(Types.LIMPIAR_DATOS_AFILIADO_FARMA_CARD_LOADING, (state) => {
    state.limpiarDatosAfiliadoFarmaCardLoading = true;
  });
});

